export default "__VITE_ASSET__0959a9a0__"